var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDraggArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 17,
    viewBox: "0 0 26 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.96 8.32031H1",
    stroke: "#9D9690",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.48 12.7998L1 8.31984L5.48 3.83984",
    stroke: "#9D9690",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 549"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 172",
    cx: 24.2838,
    cy: 1.44,
    rx: 1.44,
    ry: 1.44,
    fill: "#9D9690"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 173",
    cx: 24.2838,
    cy: 8.15875,
    rx: 1.44,
    ry: 1.44,
    fill: "#9D9690"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 174",
    cx: 24.2838,
    cy: 14.8814,
    rx: 1.44,
    ry: 1.44,
    fill: "#9D9690"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 190",
    cx: 18.522,
    cy: 1.44,
    r: 1.44,
    fill: "#9D9690"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 192",
    cx: 18.522,
    cy: 8.15875,
    rx: 1.44,
    ry: 1.44,
    fill: "#9D9690"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 194",
    cx: 18.522,
    cy: 14.8814,
    rx: 1.44,
    ry: 1.44,
    fill: "#9D9690"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggArrow);
export default __webpack_public_path__ + "static/media/draggArrow.b4bfbc4a1edd89f1f2fb02a870af6f4c.svg";
export { ForwardRef as ReactComponent };